export default "__VITE_ASSET__DoHGpJWs__"